import { render, staticRenderFns } from "./TableSummary.vue?vue&type=template&id=e97c8046"
import script from "./TableSummary.vue?vue&type=script&lang=ts"
export * from "./TableSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports